"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonHeaderToExcludeDomains = void 0;
var applicationinsights_web_1 = require("@microsoft/applicationinsights-web");
exports.commonHeaderToExcludeDomains = [
    "*.auth0.com*",
    "auth.*",
    "*.google-analytics.com*",
    "*.cookielaw.org*",
];
var validateTracingMode = function (tracingMode) {
    return Object.values(applicationinsights_web_1.DistributedTracingModes).includes(tracingMode)
        ? tracingMode
        : applicationinsights_web_1.DistributedTracingModes.W3C;
};
var getAppInsightsInstance = function (connectionString, enableCorsCorrelation, correlationHeaderExcludeDomains, tracingMode) {
    if (enableCorsCorrelation === void 0) { enableCorsCorrelation = false; }
    if (correlationHeaderExcludeDomains === void 0) { correlationHeaderExcludeDomains = []; }
    if (tracingMode === void 0) { tracingMode = applicationinsights_web_1.DistributedTracingModes.W3C; }
    var headerExcludeDomains = exports.commonHeaderToExcludeDomains.concat(correlationHeaderExcludeDomains);
    return new applicationinsights_web_1.ApplicationInsights({
        config: {
            connectionString: connectionString,
            enableCorsCorrelation: enableCorsCorrelation,
            correlationHeaderExcludedDomains: headerExcludeDomains,
            distributedTracingMode: validateTracingMode(tracingMode),
            enableRequestHeaderTracking: true,
            enableResponseHeaderTracking: true,
        },
    });
};
exports.default = getAppInsightsInstance;
